export const ValidateCoupon = ({ coupon }) => {
  if (!coupon.code) {
    return {
      field: "Code",
      error: "Coupon code is required.",
    };
  }

  if (!coupon.title) {
    return {
      field: "Title",
      error: "Title is required.",
    };
  }

  if (!coupon.discountValue || coupon.discountValue <= 0) {
    return {
      field: "Discount Value",
      error: "Discount value must be greater than zero.",
    };
  }

  if (
    !coupon.discountType ||
    !["percentage", "fixed_amount"].includes(coupon.discountType)
  ) {
    return {
      field: "Discount Type",
      error: "Discount type must be either 'percentage' or 'fixed'.",
    };
  }

  if (!coupon.appliesTo || !["all", "products"].includes(coupon.appliesTo)) {
    return {
      field: "Applies To",
      error: "Applies To must be either 'all' or 'specific'.",
    };
  }
  if (!coupon.startsAt) {
    return {
      field: "Starts at",
      error: "Starts Date cannot be blank",
    };
  }

  if (
    coupon.endsAt &&
    coupon.startsAt &&
    new Date(coupon.endsAt) <= new Date(coupon.startsAt)
  ) {
    return {
      field: "End Date",
      error: "End date must be after the start date.",
    };
  }

  if (coupon.appliesTo === "products" && !coupon.bundleIds.length) {
    return {
      field: "Bundle IDs",
      error: "You need to select at least one bundle",
    };
  }

  return null;
};
